import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCms } from '../../../store/home/actions';
import { isEmpty } from 'lodash';
import { readableCityName } from '../../../common/commonFunction';
import { useState } from 'react';

const useHomeData = (router) => {
  const dispatch = useDispatch();

  const { tradingData, featuredData, exclusiveOfferData, eventData, artistData, seoData } =
    useSelector((state) => ({
      tradingData: state.home.tradingData,
      featuredData: state.home.featuredData,
      exclusiveOfferData: state.home.exclusiveOfferData,
      eventData: state.home.eventData,
      artistData: state.home.artistData,
      seoData: state.home.seoData
    }));

  // Store previous values of city_name and category_name
  const prevCityName = useRef(router.params.city_name);
  const prevCategoryName = useRef(router.params.category_name);
  const cityName = router.params.city_name;
  const [schemaData, setSchemaData] = useState({});

  const fetchData = useCallback((sectionTitle) => {
    let requestData = { section_titles: sectionTitle, request_page: 'home' };

    if (router.params.city_name) requestData.city = readableCityName(router.params.city_name);
    if (router.params.category_name) requestData.category = router.params.category_name;

    dispatch(getCms(requestData, router.navigate));
  }, [dispatch, router.navigate, router.params.city_name, router.params.category_name]);

  useEffect(() => {
    const { city_name, category_name } = router.params;
    if (city_name !== prevCityName.current || category_name !== prevCategoryName.current) {
      // Update previous values
      prevCityName.current = city_name;
      prevCategoryName.current = category_name;
      // Call fetchData only if city or category changed
      fetchData('trending');
      fetchData('feature');
      fetchData('exclusive_offers');
      fetchData('events');
      fetchData('artists');
    } else {
      if (isEmpty(tradingData) && city_name == prevCityName.current) {
        fetchData('trending');
      }
      if (isEmpty(featuredData) && city_name == prevCityName.current) {
        fetchData('feature');
      }
      if (isEmpty(exclusiveOfferData) && city_name == prevCityName.current) {
        fetchData('exclusive_offers');
      }
      if (isEmpty(eventData) && city_name == prevCityName.current) {
        fetchData('events');
      }
      if (isEmpty(artistData) && city_name == prevCityName.current) {
        fetchData('artists');
      }
    }
  }, [router.params.city_name, router.params.category_name]);

  let sectionTitles = [
    { key: 'events', label: 'Upcoming Events in ' + cityName, data: eventData },
    { key: 'featured', label: 'Popular Events in ' + cityName, data: featuredData },
    {
      key: 'exclusive_offers',
      label: 'Events With Exclusive Offers',
      data: exclusiveOfferData,
    },
  ];

  useEffect(() => {
    if (!isEmpty(tradingData)) {
      let eventArray = [];
      tradingData.forEach((event) => {
        if (event?.event) {
          eventArray.push(event?.event);
        }
      });
      const eventListForSchema = {
        type: "CityHome",
        name: "Events in " + cityName,
        url: window.location.href,
        events: eventArray,
      };
      setSchemaData(eventListForSchema);
    }
  }, [tradingData, eventData]);

  return {
    tradingData,
    featuredData,
    exclusiveOfferData,
    eventData,
    artistData,
    seoData,
    cityName,
    sectionTitles,
    schemaData,
  };
};

export default useHomeData;
